exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-col-member-type-expired-in-day {\n  text-align: center;\n}\n", ""]);

// exports
